import { apiSlice } from "../../app/api/apiSlice";

export const menuActivityApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    recordMenuActivity: builder.mutation({
      query: (body) => ({
        url: "/menu_activitys",
        method: "POST",
        body,
      }),
      invalidatesTags: ["MenuActivity"],
    }),
    getMenuActivities: builder.query({
      query: (schoolId) =>
        schoolId ? `/menu_activitys?schoolId=${schoolId}` : "/menu_activitys",
      providesTags: ["MenuActivity"],
    }),
  }),
});

export const {
  useRecordMenuActivityMutation,
  useGetMenuActivitiesQuery,
} = menuActivityApiSlice;